<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-info`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 24C2 11.848 11.848 2 24 2s22 9.848 22 22-9.848 22-22 22S2 36.152 2 24zm23.012-4.975a1 1 0 011 1l.003 10.985h2.008a1 1 0 011 1v1.975a1 1 0 01-1 1h-8.018a1 1 0 01-1-1V32.01a1 1 0 011-1h1.99L21.991 23h-.377a1 1 0 01-1-1v-1.975a1 1 0 011-1h3.398zM24.57 13a1 1 0 011 1v2.002a1 1 0 01-1 1h-2.125a1 1 0 01-1-1V14a1 1 0 011-1h2.125zM24 42c-9.942 0-18-8.058-18-18S14.058 6 24 6s18 8.058 18 18-8.058 18-18 18z"/></svg>
</template>
<script>

export default {
  name: 'IconInfo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
